import { OrderPlanningActions } from "../../OrderPlanningActions";
import { PlanningTitle } from "../../PlanningTitle";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningEquipment extends Layout {
    layoutOPEquipTools: OrderPlanningActions;
    layoutPlanningTitle: PlanningTitle;
    panelEquipFilters: Panel;
    panelEquipMoves: Panel;
    sourceEquipMove: DataSource;
    tableEquipMoves: Table;
}
